export default (api) => {
  api.member = {
    public: {
      noticeIndex: (params = null) => api.request({
        url: `/api/member-notice/index`,
        type: 'get',
        params: {
          ...params,
          sort: { created_at: 'desc' },
        },
      }),
      setIsRead: (id) => api.request({
        url: `/api/member-notice/set-is-read/${id}`,
        type: 'post',
      }),
      readMemberPush: (id) => api.request({
        url: `/api/member-push/${id}`,
        type: 'get',
      }),
      testRecaptcha: (params) => api.request({
        url: `/api/member/recaptcha`,
        type: 'post',
        params,
      }),
      readProfile: () => api.request({
        url: `/api/member/profile`,
        type: 'get',
      }),
      updateProfile: (params) => api.request({
        url: `/api/member/profile`,
        type: 'put',
        params,
      }),
      renewToken: () => api.request({
        url: `/api/member/token`,
        type: 'put',
        ignore401Reject: true,
      }),
      register: (params) => api.request({
        url: `/api/member/register`,
        type: 'post',
        params,
      }),
      infoCheck: () => api.request({
        url: `/api/member/info/check`,
        type: 'get',
      }),
      login: (params) => api.request({
        url: `/api/member/login`,
        type: 'post',
        params,
      }),
      oauthLogin: (service, params) => api.request({
        url: `/api/member/oauth-login/${service}`,
        type: 'post',
        params,
      }),
      appleOauthLogin: (params) => api.request({
        url: `/api/oauth/apple-login`,
        type: 'post',
        params,
      }),
      loginByVerifyCode: (params) => api.request({
        url: `/api/member/verify-code/login`,
        type: 'post',
        params,
      }),
      resendVerifyEmail: (params) => api.request({
        url: `/api/member/send-mail/verify`,
        type: 'post',
        params,
      }),
      sendResetPasswordEmail: (params) => api.request({
        url: `/api/member/send-mail/reset-password`,
        type: 'post',
        params,
      }),
      createEnduringToken: (params) => api.request({
        url: `/api/member/enduring-token`,
        type: 'post',
        params,
      }),
      loginWithEnduringToken: (params) => api.request({
        url: `/api/member/enduring-token/login`,
        type: 'put',
        params,
      }),
      logoutAllDevice: () => api.request({
        url: `/api/member/logout`,
        type: 'post',
      }),
    },
    memberConsole: {
      lineConnect: (params) => api.request({
        url: `/api/member-console/line-connect`,
        type: 'post',
        params,
      }),
      lineDisconnect: () => api.request({
        url: `/api/member-console/line-disconnect`,
        type: 'post',
      }),
      verifyIdentity: (params) => api.request({
        url: `/api/member-console/verify-identity`,
        type: 'post',
        params,
      }),
      resetPassword: (params) => api.request({
        url: `/api/member-console/reset-password`,
        type: 'put',
        params,
      }),
      sendChangeEmailMail: (params) => api.request({
        url: `/api/member-console/send-mail/change-email`,
        type: 'post',
        params,
      }),
      changeEmail: (params) => api.request({
        url: `/api/member-console/email`,
        type: 'put',
        params,
      }),
      sendChangePhoneSms: (params) => api.request({
        url: `/api/member-console/send-sms/change-phone`,
        type: 'post',
        params,
      }),
      changePhone: (params) => api.request({
        url: `/api/member-console/phone`,
        type: 'put',
        params,
      }),
    },
    admin: {
      appConfig: () => api.request({
        url: `/api/admin/member/app-config`,
        type: 'get',
      }),
      index: (params = null) => api.request({
        url: `/api/admin/member/index`,
        type: 'get',
        params,
      }),
      indexTrashed: (params = null) => api.request({
        url: `/api/admin/member/index-trashed`,
        type: 'get',
        params,
      }),
      read: (id) => api.request({
        url: `/api/admin/member/${id}`,
        type: 'get',
      }),
      create: (params = {}) => api.request({
        url: `/api/admin/member`,
        type: 'post',
        params,
      }),
      updateAll: (id, params = {}) => api.request({
        url: `/api/admin/member/${id}/all`,
        type: 'put',
        params,
      }),
      update: (id, params = {}) => api.request({
        url: `/api/admin/member/${id}/update`,
        type: 'put',
        params,
      }),
      batchRestore: (ids) => api.request({
        url: `/api/admin/member/restore`,
        type: 'put',
        params: { ids },
      }),
      batchDestroy: (ids) => api.request({
        url: `/api/admin/member/destroy`,
        type: 'delete',
        params: { ids },
      }),
      batch: (params) => api.request({
        url: `/api/admin/member/batch`,
        type: 'put',
        params,
      }),
      delete: (id) => api.request({
        url: `/api/admin/member/${id}`,
        type: 'delete',
      }),
      batchDelete: (params) => api.request({
        url: `/api/admin/member/batch`,
        type: 'delete',
        params,
      }),
      resetPassword: (id, params) => api.request({
        url: `/api/admin/member/${id}/password`,
        type: 'put',
        params,
      }),
      revokePhone: (id) => api.request({
        url: `/api/admin/member/${id}/phone`,
        type: 'delete',
      }),
      export: (params) => api.request({
        url: `/api/admin/member/export`,
        type: 'post',
        params,
      }),
    },
  }

  api.memberDashboard = {
    admin: {
      overview: () => api.request({
        url: `/api/admin/member-dashboard/overview`,
        type: 'get',
      }),
    },
  }

  api.favorite = {
    public: {
      index: (type, params) => api.request({
        url: `/api/member-favorite/${type}`,
        type: 'get',
        params
      }),
      read: (type, targetId) => api.request({
        url: `/api/member-favorite/${type}/${targetId}`,
        type: 'get',
        ignore401Reject: true,
      }),
      create: (type, targetId) => api.request({
        url: `/api/member-favorite/${type}/${targetId}`,
        type: 'post',
        ignore401Reject: true,
      }),
      delete: (type, targetId) => api.request({
        url: `/api/member-favorite/${type}/${targetId}`,
        type: 'delete',
        ignore401Reject: true,
      }),
    },
  }

  api.history = {
    public: {
      index: (type, params) => api.request({
        url: `/api/member-watch-history/${type}`,
        type: 'get',
        params
      }),
      // 新聞/影集觀看紀錄
      updateWatchLog: (type, id) => api.request({
        url: `/api/member-watch-history/${type}/${id}`,
        type: 'post',
      }),
    }
  }

  api.visit = {
    public: {
      index: (params = {}) => api.request({
        url: `/api/visit/index`,
        type: 'get',
        params,
      }),
      ruleIndex: (params = {}) => api.request({
        url: `/api/visit/rules-index`,
        type: 'get',
        params,
      }),
      create: (params = {}) => api.request({
        url: `/api/visit`,
        type: 'post',
        params,
      }),
    },
    admin: {
      batchUpdateRule: (dates, period = null) => api.request({
        url: `/api/admin/visit/rules/batch`,
        type: 'post',
        params: {
          date_arr: dates,
          time_period: period,
        },
      }),
      updateRule: (date, period = null) => api.request({
        url: `/api/admin/visit/rules`,
        type: 'post',
        params: {
          date,
          time_period: period,
        },
      }),
      index: (params = null) => api.request({
        url: `/api/admin/visit/index`,
        type: 'get',
        params,
      }),
      read: (id) => api.request({
        url: `/api/admin/visit/${id}`,
        type: 'get',
      }),
      reply: (id, params) => api.request({
        url: `/api/admin/visit/reply/${id}`,
        type: 'put',
        params,
      }),
      updateAll: (id, params = {}) => api.request({
        url: `/api/admin/visit/update/${id}`,
        type: 'put',
        params,
      }),
      batch: (params) => api.request({
        url: `/api/admin/visit/batch`,
        type: 'put',
        params,
      }),
      delete: (id) => api.request({
        url: `/api/admin/visit/${id}`,
        type: 'delete',
      }),
      batchDelete: (params) => api.request({
        url: `/api/admin/visit/batch`,
        type: 'delete',
        params,
      }),
    },
  }

  api.push = {
    admin: {
      index: (params = null) => api.request({
        url: `/api/admin/member-push/index`,
        type: 'get',
        params,
      }),
      read: (id) => api.request({
        url: `/api/admin/member-push/${id}`,
        type: 'get',
      }),
      create: (params = {}) => api.request({
        url: `/api/admin/member-push`,
        type: 'post',
        params,
      }),
      updateAll: (id, params = {}) => api.request({
        url: `/api/admin/member-push/${id}`,
        type: 'put',
        params,
      }),
      batch: (params) => api.request({
        url: `/api/admin/member-push/batch`,
        type: 'put',
        params,
      }),
      delete: (id) => api.request({
        url: `/api/admin/member-push/${id}`,
        type: 'delete',
      }),
      batchDelete: (params) => api.request({
        url: `/api/admin/member-push/batch`,
        type: 'delete',
        params,
      }),
    },
  }

  api.representation = {
    public: {
      index: (params = {}) => api.request({
        url: `/api/representation/index`,
        type: 'get',
        params,
      }),
      read: (id) => api.request({
        url: `/api/representation/${id}`,
        type: 'get',
      }),
      create: (params) => api.request({
        url: `/api/representation`,
        type: 'post',
        params,
      }),
    },
    admin: {
      index: (params = null) => api.request({
        url: `/api/admin/representation/index`,
        type: 'get',
        params,
      }),
      read: (id) => api.request({
        url: `/api/admin/representation/${id}`,
        type: 'get',
      }),
      create: (params) => api.request({
        url: `/api/admin/representation`,
        type: 'post',
        params,
      }),
      updateAll: (id, params = {}) => api.request({
        url: `/api/admin/representation/${id}`,
        type: 'put',
        params,
      }),
      batch: (params) => api.request({
        url: `/api/admin/representation/batch`,
        type: 'put',
        params,
      }),
      delete: (id) => api.request({
        url: `/api/admin/representation/${id}`,
        type: 'delete',
      }),
      batchDelete: (params) => api.request({
        url: `/api/admin/representation/batch`,
        type: 'delete',
        params,
      }),
    },
  }

  api.customerService = {
    public: {
      readByCode: (params) => api.request({
        url: `/api/customer-service/read-by-code`,
        type: 'get',
        tokenTypeLimit: 'member',
        params
      }),
      create: (params) => api.request({
        url: `/api/customer-service`,
        type: 'post',
        tokenTypeLimit: 'member',
        params
      }),
      read: (id) => api.request({
        url: `/api/customer-service/read/${id}`,
        type: 'get',
      }),
      index: (params = {}) => api.request({
        url: `/api/customer-service/index`,
        type: 'get',
        tokenTypeLimit: 'member',
        params: {
          sort: { created_at: 'desc' },
          ...params,
        },
      }),
    },
    admin: {
      index: (params = null) => api.request({
        url: `/api/admin/customer-service/index`,
        type: 'get',
        params,
      }),
      exportIndex: (params = null) => api.request({
        url: `/api/admin/customer-service/export-index`,
        type: 'get',
        params,
      }),
      read: (id) => api.request({
        url: `/api/admin/customer-service/read/${id}`,
        type: 'get',
      }),
      create: (params = {}) => api.request({
        url: `/api/admin/customer-service`,
        type: 'post',
        params,
      }),
      reply: (id, params = {}) => api.request({
        url: `/api/admin/customer-service/reply/${id}`,
        type: 'post',
        params,
      }),
      redirect: (id, params = {}) => api.request({
        url: `/api/admin/customer-service/redirect/${id}`,
        type: 'post',
        params,
      }),
      updateAll: (id, params = {}) => api.request({
        url: `/api/admin/customer-service/${id}/all`,
        type: 'put',
        params,
      }),
      update: (id, params = {}) => api.request({
        url: `/api/admin/customer-service/${id}/update`,
        type: 'put',
        params,
      }),
      changeStatus: (id, params = {}) => api.request({
        url: `/api/admin/customer-service/${id}/status`,
        type: 'put',
        params,
      }),
      batch: (params) => api.request({
        url: `/api/admin/customer-service/batch`,
        type: 'put',
        params,
      }),
      delete: (id) => api.request({
        url: `/api/admin/customer-service/${id}`,
        type: 'delete',
      }),
      batchDelete: (params) => api.request({
        url: `/api/admin/customer-service/batch`,
        type: 'delete',
        params,
      }),
    },
  }

  api.memberBonus = {
    admin: {
      index: (params) => api.request({
        url: `/api/admin/member-bonus/index`,
        type: 'get',
        params
      }),
    },
  }

  api.customerServiceFaq = {
    public: {
    },
    admin: {
      index: (params = null) => api.request({
        url: `/api/admin/customer-service-faq/index`,
        type: 'get',
        params,
      }),
      read: (id) => api.request({
        url: `/api/admin/customer-service-faq/${id}`,
        type: 'get',
      }),
      create: (params = {}) => api.request({
        url: `/api/admin/customer-service-faq`,
        type: 'post',
        params,
      }),
      updateAll: (id, params = {}) => api.request({
        url: `/api/admin/customer-service-faq/${id}/all`,
        type: 'put',
        params,
      }),
      update: (id, params = {}) => api.request({
        url: `/api/admin/customer-service-faq/${id}/update`,
        type: 'put',
        params,
      }),
      batch: (params) => api.request({
        url: `/api/admin/customer-service-faq/batch`,
        type: 'put',
        params,
      }),
      delete: (id) => api.request({
        url: `/api/admin/customer-service-faq/${id}`,
        type: 'delete',
      }),
      batchDelete: (params) => api.request({
        url: `/api/admin/customer-service-faq/batch`,
        type: 'delete',
        params,
      }),
    },
  }
}